// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"3a74c8a087c12577f8c5","263":"e53c0145f118df2f5218","791":"a0d47cfa40cc7916c338"}[chunkId] + ".js";
};